<template>
  <div class="leaves">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Loans</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Loan History</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!-- Leave Statistics -->
          <div class="row">
            <div class="col-md-3" v-for="item in loanTypes" :key="item.typeId">
              <div class="stats-info">
                <h6>{{ item.description }}</h6>
                <h5>{{ item.tenor }} Months Maximum</h5>
              </div>
            </div>
          </div>
          <!-- /Leave Statistics -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="loans"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link to="/profile" class="avatar"
                        ><img alt="" src="~@/assets/profiles/avatar-02.jpg"
                      /></router-link>
                      <router-link to="/profile">{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</router-link>
                    </h2>
                  </template>
                  <template v-slot:[`item.requestDate`]="{ item }">
                    {{
                      item.toDate
                        ? new Date(item.requestDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setEditLoan(item)"
                          v-if="
                            item.status == 0 && item.amount != 0 && item.approvedByManager == null
                          "
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" @click="onDownload(item)" v-if="(item.loanTypeId == 3 || item.loanTypeId == 4) && item.status == 1"
                          ><i class="fa fa-file-o m-r-5"></i> Download Certificate</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setDeleteLoan(item)"
                          v-if="item.approvedByManager == null"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 &&  item.nextApproval"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting
                      Manager Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="
                        item.status == 0 &&
                          !item.nextApproval &&
                          !item.approvedBy
                      "
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting HR
                      Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1 && !item.updatedByHCRM"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Awaiting
                      Payroll Update
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1 && item.updatedByHCRM"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>

                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
          <!-- /Page Content -->
        </div>
        <!-- /Page Wrapper -->
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import Datepicker from "vuejs-datepicker";
import { organizationService } from "@/services/organizationService";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      submitted: false,
      media: "data:image/jpeg;base64,",
      headers: [
        { text: "Employee", value: "profile" },
        { text: "Loan Type", value: "loanType.description" },
        { text: "Amount", value: "amount" },
        { text: "Tenor (per month)", value: "actualTenor" },
        { text: "Repayment Amount", value: "repaymentAmount" },
        { text: "Repayment StartDate", value: "repaymentStartDate" },
        { text: "Status", value: "stat" }
      ],
      loanTypeId: 0,
      amount: 0,
      tenor: 0,
      loan: {},
      loans: [],
      loanType: {},
      loanTypes: [],
      maxTenor: 0,
      amountReadonly: false,
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue,
      error: "",
      message: "",
      status: ""
    };
  },

  watch: {
    tenor(val) {
      if (val > 0 && this.amount > 0 && this.loanTypeId > 0) {
        this.calculateLoan(val);
      }
    },
  },
  computed: {},

  methods: {
    clearModel() {
      this.amount = 0;
      this.tenor = 0;
      this.loanTypeId = 0;
      this.loan.repaymentAmount = "";
      this.loan.repaymentStartDate = "";
      this.submitted = false;
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },

    openDialog() {
      this.dialog = true;
    },

    closeEdit() {
      this.dialogEdit = false;
    },

    closeStatus() {
      this.dialogStatus = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    setEditLoan(item) {
      this.loan = item;
      this.dialogEdit = true;
      // console.log(`item`, item)
    },

    setDeleteLoan(item) {
      this.loan = item;
      this.dialogDelete = true;
    },

    setLoan(item) {
      this.loan = item;
    },

    checkLoanTypes() {
      var type = this.loanTypes.find(c => (c.id == this.loanTypeId));
      if (type) {
        if(type.description.toUpperCase().match('CAR')) {
          employeeService.getAmountByLoanType(type.id, this.user.employee.rankId)
          .then(a => {
            this.amount = a; this.tenor = type.tenor;
            this.maxTenor = type.tenor;
            this.loanType = type;
            this.amountReadonly = true;
            this.loan = {id:0, employeeId:0, loanTypeId:type.id, amount: a, actualTenor:type.tenor, repaymentAmount: (a / type.tenor), repaymentStartDate: new Date().toISOString()}
          } )
        } else if (type.description.toUpperCase().match('HOUS')) {
          employeeService.getAmountByLoanType(type.id, this.$route.params.id)
          .then(a => {
            this.amount = a; this.tenor = type.tenor;
            this.maxTenor = type.tenor;
            this.loanType = type;
            this.amountReadonly = true;
            this.loan = {id:0, employeeId:0, loanTypeId:type.id, amount:a, actualTenor:type.tenor, repaymentAmount: (a / type.tenor), repaymentStartDate: new Date().toISOString()}
          } )
        } else {
          this.maxTenor = type.tenor;
          this.loanType = type;
          if(type.calculatedRequestAmount){
            this.loan = {id:0,
              employeeId:0,
              loanTypeId:type.id,
              amount:0,
              actualTenor:0,
              repaymentAmount:0,
              repaymentStartDate:"0001-01-01T00:00:00",
              }
            }
        }
      } else {
        this.maxTenor = 6;
      }
    },
    onDownload(loan) {
      this.loading = true
      employeeService.exportCertificate(loan.id, loan.loanTypeId)
      .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
          this.loading = false;
        }).catch((error) => {
            alert(error);
            this.loading = false;
        });
    },
    checkLoanTypesWithExist() {
      this.loanType = this.loanTypes.find(c => c.id == this.loan.loanTypeId);
    },
    getLoans() {
      employeeService.getLoanRequestsByEmployee(this.$route.params.id).then(
        o => {
          this.loans = o;
        },
        error => {
          error = error;
        }
      );
    },
    getLoanTypes() {
      employeeService.getLoanTypes(this.company.id).then(
        model => {
          this.loanTypes = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;
      this.loading = true;
      this.loan.requestDate = new Date();
      this.loan.employeeId = this.$route.params.id;
      this.loan.loanType = null;
      employeeService.addLoanRequest(this.loan).then(
        id => {
          this.message = "Loan Request Added successfully";
          employeeService
            .getLoanRequestsByEmployee(this.$route.params.id)
            .then(model => {
              this.loans = model;
              this.message = "";
              this.loanTypeId = 0;
              this.close();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    calculateLoan(tenor) {
      this.submitted = true;
      this.loading = true;
      var loan = {
        loanTypeId: this.loanTypeId,
        amount: this.amount,
        actualTenor: tenor
      };
      employeeService.calculateLoan(loan).then(
        model => {
          this.loan = model;
          this.submitted = false;
          this.loan.repaymentStartDate = new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            new Date().getDate()
          );
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },
  mounted() {
    this.getLoanTypes();
    this.getLoans();

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
  },
  name: "leaves"
};
</script>



// WEBPACK FOOTER //
// src/components/loans/loan/loanHistory.vue